import { useCallback, useEffect } from "react";
import { apiTags } from "../services";
import { useTrendingTagsStore } from "../store/trendingTagsStore";
import { useFetch } from "./useFetch";

export const useGetTrendingTags = () => {
  const trendingTags = useTrendingTagsStore(state => state.trendingTags);
  const setTrendingTags = useTrendingTagsStore(state => state.setTrendingTags);

  const fetchTrendingTags = useCallback(() => apiTags.getTrendingTags(), []);
  const { isLoading, error, data } = useFetch(fetchTrendingTags, !trendingTags.length);

  useEffect(() => {
    if (!error && data) {
      setTrendingTags(data);
    }
  }, [error, data, setTrendingTags]);

  return {
    trendingTags: trendingTags ?? [],
    isLoading,
    error,
  };
};
